import { render, staticRenderFns } from "./MessageSearchItem.vue?vue&type=template&id=6d7f483a"
import script from "./MessageSearchItem.vue?vue&type=script&lang=js"
export * from "./MessageSearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports